<template>
  <el-dialog
    title="分类设置"
    append-to-body
    :visible.sync="visible"
    :before-close="handleCloseRight"
  >
    <div class="addParent table_edit">
      <el-button type="text" @click="edit({}, 0)" class="add-child">
        <i class="el-icon-circle-plus"></i>
        <span>&nbsp;添加分类</span>
      </el-button>
    </div>
    <el-tree
      :data="tree"
      node-key="id"
      default-expand-all
      :expand-on-click-node="false"
      :props="{
        children: 'child',
        label: 'title',
      }"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="() => edit(data, 0)"
            v-if="!data.parentId"
          >
            新增
          </el-button>
          <el-button type="text" size="mini" @click="() => edit(data, 1)">
            编辑
          </el-button>
          <el-button type="text" size="mini" @click="() => remove(data)">
            删除
          </el-button>
        </span>
      </span>
    </el-tree>
  </el-dialog>
</template>
<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      tree: []
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['selfAreaId'])
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      Api.getCategory({ selfAreaId: this.selfAreaId }).then(({ data }) => {
        this.tree = data
      })
    },
    edit(data, type) {
      console.log(data)
      this.$prompt('请输入分类名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: type === 1 ? data.title : '',
        inputPattern: /\S/,
        inputErrorMessage: '不能为空'
      })
        .then(({ value }) => {
          let postdata
          if (type === 1) {
            // 编辑
            postdata = {
              id: data.id,
              areaId: data.areaId,
              title: value,
              sort: data.sort,
              parentId: data.parentId || 0
            }
          } else {
            // 新增
            postdata = {
              id: 0,
              areaId: this.selfAreaId,
              title: value,
              parentId: data.id ? data.id : 0
            }
          }
          Api.editCategory({ selfAreaId: this.selfAreaId }, postdata).then(
            res => {
              if (res.code === 200) {
                this.init()
              } else {
                this.$message.error(res.message)
              }
            }
          )
        })
        .catch()
    },
    remove(data) {
      Api.delCategory(data.id, this.selfAreaId).then((res) => {
        if (res.code === 200) {
          this.init()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleCloseRight() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 0 20px 20px 20px;
}
.custom-tree-node {
  display: flex;
  width: 85%;
  align-items: center;
  > span:last-child {
    width: 100px;
  }
  > span:first-child {
    flex: 1;
  }
}
</style>
